import { render, staticRenderFns } from "./fi_classic_sunset_notice.vue?vue&type=template&id=b73d2824&scoped=true&"
import script from "./fi_classic_sunset_notice.vue?vue&type=script&lang=js&"
export * from "./fi_classic_sunset_notice.vue?vue&type=script&lang=js&"
import style0 from "./fi_classic_sunset_notice.vue?vue&type=style&index=0&id=b73d2824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73d2824",
  null
  
)

export default component.exports